import axios from "axios"

export function getCardsConfiguration() {
    return axios({method: 'get', url:'/.netlify/functions/cardsConfiguration'}).then((response) => {
        return response.data.cards_configuration
    }).catch(err => {
        return {}
    })
}
 